export default {
    url: '/report/:guid?comparisonGuid&siteId&comparisonSiteId',
    template: '<evaluation-public-report></evaluation-public-report>'
};



// WEBPACK FOOTER //
// ./src/app/states/evaluation/report/index.js